<template>
  <div :class="['pop animated', animat]">
    <div class="pop-box" v-if="list.length">
      <img :src="user.avatar || ''" class="logo" />
      <div class="name no-warp">{{ user.name || "" }}</div>
      <div class="order no-warp">
        {{ user.title || "" }} × <span class="num">{{ user.num || 1 }}</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.pop {
  position: fixed;
  top: 1.5rem;
  left: 0.25rem;
  background: rgba(0, 0, 0, 0.7);
  width: auto;
  min-width: 60%;
  padding-right: 0.1rem;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 3px #ffffff;
  color: #ffffff;
  font-size: 0.24rem;
  &-box {
    padding: 0 0.1rem;
    display: flex;
    align-items: center;
    height: 0.6rem;
  }
  .num {
    color: yellow;
  }
  .logo {
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 100%;
    margin-right: 0.2rem;
  }
  .no-warp {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    box-sizing: content-box;
  }
  .name {
    flex-grow: 1;
  }
  .order {
    margin-left: 0.1rem;
  }
  z-index: 999;
}
.hide {
  display: none;
}
</style>
<script>
import { getBuyPop } from "@/api/order.js";
export default {
  name: "BuyPop",
  data: function() {
    return {
      index: 0,
      list: [],
      aIndex: 0,
      animatedInArr: [
        "fadeIn",
        "fadeInLeft",
        "fadeInLeftBig",
        "fadeInRight",
        "fadeInRightBig",
        "fadeInUp",
        "fadeInUpBig",
        "bounceIn",
        "bounceInDown"
      ],
      animatedOutArr: [
        "fadeOut",
        "fadeOutLeft",
        "fadeOutLeftBig",
        "fadeOutRight",
        "fadeOutRightBig",
        "fadeOutUp",
        "fadeOutUpBig",
        "bounceOut",
        "bounceOutDown"
      ],
      animat: "hide",
      user: {}
    };
  },
  created: function() {},
  mounted: function() {
    this.getList();
    this.ani();
  },
  methods: {
    ani() {
      setTimeout(() => {
        let i = this.index; //
        if (this.list.length - 1 <= i++) i = 0;
        this.index = i;
        this.user = this.list[i]; // 切换用户
        i = this.aIndex;
        if (this.animatedInArr.length - 1 <= i++) i = 0;
        this.aIndex = i;
        this.animat = this.animatedInArr[i]; // 进入

        setTimeout(() => {
          this.animat = "";

          setTimeout(() => {
            this.animat = this.animatedOutArr[i]; // 出去
            setTimeout(() => {
              this.animat = "hide";
              this.ani();
            }, 3500);
          }, 1500);
        }, 2500);
      }, 2500);
    },
    getList() {
      getBuyPop()
        .then(r => {
          this.list = r.data || [];
          this.user = this.list[0] || [];
        })
        .catch(msg => {
          console.log(msg);
        });
    }
  }
};
</script>
